import { render, staticRenderFns } from "./EditableToolbar.vue?vue&type=template&id=0ffc1632&"
import script from "./EditableToolbar.vue?vue&type=script&lang=js&"
export * from "./EditableToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports